import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import type { ReactElement } from 'react'
import { NoResult } from '~/components/Global/Elements/NoResult/NoResult'
import { MessagingContextPanel } from './MessagingContextPanel'

/** The conversation is visible (direct correspondent) but the record itself is not */
export const MessagingContextAccessDenied = ({
  description,
  onToggle
}: {
  description: string
  onToggle?: () => void
}): ReactElement => (
  <MessagingContextPanel onToggle={onToggle}>
    <NoResult
      icon={faExclamationTriangle}
      isError
      isSmall
      message="Accès refusé"
      description={description}
    />
  </MessagingContextPanel>
)
